// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"t2tZZGheeJGKS8Oq-jSzgw==","tags":"bqcQTkIYjgNJ8gbZnDQ7tw==","tag":"RsAyhkumyuFu1hmGVla8vw=="};